import { useMutation } from "@apollo/client";
import React, { useState } from "react";
import { RESET_PASSWORD_MUTATION } from "../GraphQl/Mutations";
import { FaSpinner } from "react-icons/fa";
import Loader from "../components/Loader";

const ResetPassword = () => {
  // const resetPassword = () => { };
  const [tempEmail, setTempEmail] = useState(null);
  const [resetPassword, { loading }] = useMutation(RESET_PASSWORD_MUTATION, {
    variables: {
      email: tempEmail,
      // email: "slggourav@gmail.com",
    },
    onCompleted: (data) => {
      console.log(data);
    },
    onError: (err) => {
      console.log(err);
    },
  });
  return (
    <section className='resetPasswordWrapper'>
      <div className='sectionHeaderWrapper flex items-center content-between'>
        <div className='sectionHeaderTitle'> Forgot Password ?</div>
      </div>
      <div className='sectionContentWrapper'>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            resetPassword();
          }}
          className='resetPasswordForm'
        >
          <input
            type='text'
            className='form-control'
            id='resetEmail'
            placeholder='Enter email id registered with us'
            required
            onKeyUp={(e) => setTempEmail(e.target.value)}
          />
          <button className='btn btn-primary'>
            {loading && <Loader color='#fff' />} Send Reset Link
          </button>
        </form>
      </div>
    </section>
  );
};

export default ResetPassword;
